import { render, staticRenderFns } from "./GetCustomerStatu.vue?vue&type=template&id=7183c320&scoped=true&"
import script from "./GetCustomerStatu.vue?vue&type=script&lang=js&"
export * from "./GetCustomerStatu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7183c320",
  null
  
)

export default component.exports